require('assets/sass/public.scss');

// Dependencies
var $ = require('jquery');
var Backbone = require('backbone');
var Radio = require('backbone.radio');
var Marionette = require('backbone.marionette');
require('app/common/ajax-csrf');
require('app/common/configureSentry');

new (require('app/entities/config')).API();
new (require('app/entities/constants')).API();

// Register Apps
require('app/public-app/apps');

var app = new Marionette.Application();

// Channels
var channel = Radio.channel('global');

// Global Commands
new (require('app/common/commands/show-error'))();
new (require('app/common/commands/show-modal'))();
var GetRegions = require('app/common/commands/get-regions');

// Regions
app.addRegions({
    mainRegion: '#main-region',
    modalRegion: '#modal-region',
});

new GetRegions({
    regions: app.getRegions(),
});

// Initializers
app.on('start', function() {
    var configPromise = channel.request('config');
    var constantsPromise = channel.request('constants');
    var constantsGroupsPromise = channel.request('constants:groups');

    $.when(configPromise, constantsPromise, constantsGroupsPromise).then(
        // Success
        function() {
            channel.trigger('app:loaded');
        },
        // Error
        function(e) {
            channel.request('show:error', app.mainRegion, e);
        }
    );
});

channel.on('app:loaded', function() {
    Backbone.history.start({
        pushState: true,
        hashChange: false,
    });
});

app.start();
